import { useEffect } from 'react'
import { RadioGroup } from 'entities/RadioGroup'
import { useConfigStore } from 'shared/store/configSlice'
import { useGlobalStore } from 'shared/store/globalSlice'
import { getAppName } from 'shared/helpers/getAppName'
import { appThemeOptions } from './options'

export const ThemeSelector = () => {
  const updateInterface = useConfigStore().updateInterface
  const config = useConfigStore().config
  const isConfigLoaded = useConfigStore().isConfigLoaded
  const isCC = useGlobalStore().isCCSelected
  const appTheme = config?.interfaceConfig?.[getAppName(isCC)]?.appTheme

  useEffect(() => {
    if (!appTheme && isConfigLoaded) {
      updateTheme(appThemeOptions?.[0]?.value)
    }
  }, [appTheme, isConfigLoaded])

  const updateTheme = (value: string) => {
    updateInterface({ appTheme: value as 'light' })
  }

  return (
    <RadioGroup
      key={`theme_Selector${appTheme}`}
      options={appThemeOptions}
      value={appTheme}
      handleChange={updateTheme}
      title='Theme'
      sx={{
        width: '720px',
        display: 'grid',
        gap: '10px',
        gridTemplateColumns: 'repeat(auto-fill, 233px)'
      }}
    />
  )
}
